import {
  GET_PRODUCT_FETCH,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_REJECTED,
  apiUrl,
  GET_PRODUCT_CLEAR,
  GET_PROJECT_FETCH,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_REJECTED,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const getProduct = (countryid, departid, brandid, year) => {
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_FETCH });
    return httpClient
      .get(`${apiUrl}/products/${countryid}/${brandid}/${departid}/${year}`)
      .then((result) => {
        dispatch({ type: GET_PRODUCT_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: GET_PRODUCT_REJECTED });
      });
  };
};

export const getAllProjects = (
  countryid,
  departid,
  brandid,
  yearcode,
  bgidx
) => {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_FETCH });
    return httpClient
      .get(
        `/products/projects/${countryid}/${brandid}/${departid}/${yearcode}/${bgidx}`
      )
      .then((result) => {
        dispatch({ type: GET_PROJECT_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: GET_PROJECT_REJECTED });
      });
  };
};

export const clearProductItem = () => {
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_CLEAR });
  };
};
